import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/product/correct.svg'
import _imports_1 from '@/assets/thumbtack.png'


const _withScopeId = n => (_pushScopeId("data-v-f758e620"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "about_us_view" }
const _hoisted_2 = { class: "headline" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "company_thumbnail" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/company_home.jpg",
    alt: ""
  })
], -1))
const _hoisted_7 = { class: "company_activity" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "asset" }
const _hoisted_10 = { class: "label" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "thumbtack"
}, null, -1))
const _hoisted_12 = { class: "introduce_left" }
const _hoisted_13 = { class: "options" }

import { computed, inject, onMounted, reactive, ref } from "vue";
import provide_key from "@/constant/provide_key";
import FormBar from "./FormBar.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'AboutUsView',
  setup(__props) {

const shrink: boolean | undefined = inject(provide_key.SHRINK);

const activities1 = [
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/company_activity.jpg",
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/company_activity_1.jpg",
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/company_activity_2.jpg",
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/company_activity_3.jpg",
];

const activities2 = [
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/company_activity_4.jpg",
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/company_activity_5.jpg",
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/company_activity_6.jpg",
  "https://portal-1325821575.cos.ap-guangzhou.myqcloud.com/about_us/company_activity_7.jpg",
];

const activities = ref(activities1);

const currentIndex = ref(0);

onMounted(() => {
  setInterval(() => {
    currentIndex.value = (currentIndex.value + 1) % activities1.length; // 更新当前索引
    if(currentIndex.value == 0) {
      if(activities.value[0] == activities1[0]) {
        activities.value = activities2;
      } else {
        activities.value = activities1;
      }}
  }, 2000); // 每隔两秒
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "top_content",
      style: _normalizeStyle({'flex-direction': _unref(shrink) ? 'column-reverse' : 'row'})
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("company.WIND_TO_LIQUID_COOLING_SOLUTION")), 1),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (item, index) => {
            return _createElementVNode("div", {
              key: index,
              class: "text_item"
            }, [
              _hoisted_5,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t(`company.SOLUTION_SPAN_${index + 1}`)), 1)
            ])
          }), 64))
        ])
      ]),
      _hoisted_6
    ], 4),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_TransitionGroup, { name: "scaleUp" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activities.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["activity_item", { 'scale-up': currentIndex.value === index }]),
              key: index
            }, [
              _createElementVNode("img", {
                src: item,
                alt: ""
              }, null, 8, _hoisted_8)
            ], 2))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("company.CONTACT_US")), 1),
      _createElementVNode("div", {
        class: "introduce",
        style: _normalizeStyle({ 'flex-direction': _unref(shrink) ? 'column' : 'row' })
      }, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (item, index) => {
              return _createElementVNode("div", {
                class: "option",
                key: index
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t(`company.WHY_LIQUID_COOLING_DESCRIPTION_0${index + 1}`)), 1)
              ])
            }), 64))
          ])
        ]),
        _createVNode(FormBar)
      ], 4)
    ])
  ]))
}
}

})